{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "Tingkatkan",
    "navBilling": "Penagihan"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "Tab Anda. <em>Zikir</em> Anda.<br />Lebih bermakna.",
    "subtitle": "Setiap fitur yang Anda butuhkan untuk hari yang lebih bermakna — dari waktu salat dan refleksi ayat AI hingga cuaca dan tugas prioritas — dalam satu tab baru yang tenang dan indah.",
    "comparison_aria": "Perbandingan paket",
    "free": {
      "tierLabel": "Saat ini",
      "tierName": "Gratis",
      "freeLabel": "Selalu gratis",
      "list_aria": "Fitur paket gratis"
    },
    "pro": {
      "list_aria": "Fitur paket Pro",
      "tierLabel": "Tingkatkan ke",
      "tierName": "Pro",
      "pricePeriod": "/ bulan",
      "priceAlt": "atau $39.99 / tahun"
    },
    "freeFeatures": {
      "clockDate": "Tampilan jam & tanggal",
      "verseOfDay": "Ayat Quran harian",
      "dailyBackground": "Foto latar belakang harian",
      "qiblaCompass": "Kompas kiblat",
      "basicTasks": "Tugas dasar"
    },
    "proFeatures": {
      "weatherForecast": "Prakiraan cuaca 5 hari",
      "verseFavorites": "Simpan & jelajahi ayat favorit",
      "notesAi": "Catatan dengan analisis AI",
      "priorityTasks": "Manajemen tugas prioritas",
      "verseReflection": "Refleksi ayat dengan AI"
    },
    "plans": {
      "monthly": {
        "label": "Bulanan",
        "price": "$4.99",
        "period": "/ bulan",
        "note": "Ditagih bulanan"
      },
      "yearly": {
        "label": "Tahunan",
        "price": "$39.99",
        "period": "/ tahun",
        "note": "Dua bulan gratis",
        "badge": "Hemat 33%"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "Batalkan kapan saja. Akses Anda berlanjut hingga akhir periode penagihan tanpa biaya sebagian.",
    "billingPeriod_aria": "Periode penagihan",
    "cta": "Lanjutkan ke pembayaran aman",
    "ctaLoading": "Mengalihkan ke pembayaran…",
    "promoManual": "Masukkan kode {{code}} di halaman berikutnya untuk mendapatkan diskon.",
    "signingUpAs": "Mendaftar sebagai {{account}}",
    "trustSignals_aria": "Sinyal kepercayaan",
    "reassurance": {
      "secureCheckout": "Pembayaran aman melalui Stripe",
      "cancelAnytime": "Batalkan kapan saja, tanpa pertanyaan",
      "accessUntilEnd": "Akses hingga akhir periode"
    },
    "errors": {
      "restoreSession": "Tidak dapat memulihkan sesi Anda. Silakan coba lagi dari ekstensi.",
      "checkoutFailed": "Gagal memulai pembayaran. Silakan coba lagi."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "Fitur yang terbuka",
    "unlockedFeatures": {
      "weatherForecast": "Prakiraan cuaca 5 hari",
      "verseFavorites": "Simpan dan jelajahi ayat favorit",
      "notesAi": "Catatan dengan analisis AI",
      "priorityTasks": "Manajemen tugas prioritas",
      "verseReflection": "Refleksi ayat dengan AI"
    },
    "success": {
      "title": "Selamat datang di Pro",
      "desc": "Langganan Anda aktif. Kembali ke ekstensi untuk menemukan semua fitur Pro menanti Anda.",
      "viewBilling": "Lihat detail penagihan",
      "closeTab": "Tutup tab ini"
    },
    "cancel": {
      "title": "Pembayaran dibatalkan",
      "desc": "Tidak masalah — paket Anda tidak diubah dan Anda tidak dikenai biaya. Anda dapat meningkatkan kapan pun Anda siap.",
      "backToUpgrade": "Kembali ke peningkatan",
      "returnToExtension": "Kembali ke ekstensi"
    }
  },
  "billing": {
    "title": "Penagihan",
    "subtitle": "Kelola langganan Anda dan lihat riwayat pembayaran.",
    "subscription_aria": "Status langganan",
    "subscriptionTitle": "Langganan",
    "loading_aria": "Memuat informasi penagihan",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Gratis",
    "statusLabels": {
      "active": "Aktif",
      "trialing": "Uji coba gratis",
      "past_due": "Jatuh tempo",
      "unpaid": "Belum dibayar",
      "canceled": "Dibatalkan",
      "incomplete": "Tidak lengkap",
      "none": "Tidak ada langganan"
    },
    "planValues": {
      "proYearly": "Pro · Tahunan",
      "proMonthly": "Pro · Bulanan"
    },
    "warnings": {
      "paymentFailedTitle": "Pembayaran gagal",
      "paymentFailedDesc": "Pembayaran terakhir Anda tidak berhasil. Perbarui metode pembayaran Anda melalui Kelola Penagihan untuk mempertahankan akses Pro.",
      "trialEndingTitle": "Uji coba segera berakhir",
      "trialEndingToday": "Uji coba gratis Anda berakhir hari ini pada {{date}}. Tambahkan metode pembayaran untuk mempertahankan fitur Pro Anda.",
      "trialEndingInDays_one": "Uji coba gratis Anda berakhir dalam {{count}} hari pada {{date}}. Tambahkan metode pembayaran untuk mempertahankan fitur Pro Anda.",
      "trialEndingInDays_other": "Uji coba gratis Anda berakhir dalam {{count}} hari pada {{date}}. Tambahkan metode pembayaran untuk mempertahankan fitur Pro Anda."
    },
    "cancellationScheduled": "Pembatalan dijadwalkan. Anda tetap memiliki akses Pro penuh hingga <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "Uji coba berakhir hari ini",
      "trialDaysRemaining_one": "{{count}} hari tersisa dalam uji coba",
      "trialDaysRemaining_other": "{{count}} hari tersisa dalam uji coba",
      "renews": "Diperbarui {{date}}",
      "accessUntil": "Akses hingga {{date}}"
    },
    "kv": {
      "status": "Status",
      "nextRenewal": "Pembaruan berikutnya",
      "trialEnds": "Uji coba berakhir",
      "trialDaysLeft_one": "{{count}} hari tersisa",
      "trialDaysLeft_other": "{{count}} hari tersisa",
      "endsToday": "berakhir hari ini",
      "plan": "Paket"
    },
    "upgradeNudge": {
      "title": "Buka fitur Pro",
      "desc": "Cuaca, waktu salat, refleksi ayat AI, dan lainnya — $4.99/bulan atau $39.99/tahun.",
      "cta": "Tingkatkan"
    },
    "actions": {
      "manageBilling": "Kelola penagihan & metode pembayaran",
      "cancelConfirmTitle": "Batalkan langganan Anda?",
      "cancelConfirmDesc": "Anda akan tetap memiliki akses Pro penuh hingga akhir periode penagihan Anda saat ini. Tidak ada pengembalian dana sebagian.",
      "canceling": "Membatalkan…",
      "yesCancel": "Ya, batalkan",
      "keepPro": "Pertahankan Pro",
      "cancelSubscription": "Batalkan langganan"
    },
    "noSubscription": "Tidak ada langganan ditemukan.",
    "paymentHistory_aria": "Riwayat pembayaran",
    "paymentHistoryTitle": "Riwayat pembayaran",
    "invoices_aria": "Faktur",
    "invoiceView": "Lihat",
    "invoiceView_aria": "Lihat faktur dari {{date}}",
    "noInvoices": "Belum ada faktur.",
    "dangerZone_aria": "Zona berbahaya",
    "dangerZoneTitle": "Zona berbahaya",
    "deleteAccountTitle": "Hapus akun",
    "deleteAccountDesc": "Hapus akun Anda dan semua data terkait secara permanen — tugas, catatan, favorit, dan riwayat penagihan. Tindakan ini tidak dapat dibatalkan.",
    "deleteAccountBtn": "Hapus akun",
    "deleteConfirm": {
      "warning": "Ini akan segera dan secara permanen:",
      "list": {
        "deleteContent": "Menghapus semua tugas, catatan, dan ayat favorit Anda",
        "cancelSubscription": "Membatalkan langganan aktif apa pun (tanpa pengembalian dana untuk waktu yang tidak terpakai)",
        "removeAccount": "Menghapus akun Anda dari basis data kami",
        "signOut": "Mengeluarkan Anda dari semua perangkat"
      },
      "typeToConfirm": "Ketik <strong>DELETE</strong> untuk mengonfirmasi",
      "inputPlaceholder": "DELETE",
      "deleting": "Menghapus…",
      "confirmBtn": "Hapus akun saya secara permanen",
      "cancelBtn": "Batal"
    },
    "errors": {
      "loadFailed": "Gagal memuat informasi penagihan.",
      "cancelFailed": "Gagal membatalkan langganan.",
      "deleteFailed": "Gagal menghapus akun. Silakan coba lagi atau hubungi dukungan.",
      "portalFailed": "Gagal membuka portal penagihan."
    }
  },
  "privacy": {
    "tocLabel": "Kebijakan Privasi",
    "toc_aria": "Daftar isi",
    "lastUpdated": "Terakhir diperbarui<br />22 September 2026",
    "sections": {
      "overview": "Ikhtisar",
      "informationWeCollect": "Informasi yang Kami Kumpulkan",
      "connectedServices": "Layanan yang Terhubung (Google, Todoist, Apple)",
      "howWeUse": "Bagaimana Kami Menggunakan Informasi Anda",
      "howWeShare": "Bagaimana Kami Membagikan Informasi Anda",
      "dataRetention": "Penyimpanan Data",
      "yourRights": "Hak Privasi Anda",
      "california": "Penduduk California (CCPA/CPRA)",
      "cookies": "Kuki & Penyimpanan Lokal",
      "security": "Keamanan Data",
      "changes": "Perubahan pada Kebijakan Ini",
      "contact": "Hubungi Kami"
    },
    "headings": {
      "informationWeCollect": "Informasi yang Kami Kumpulkan",
      "connectedServices": "Layanan yang Terhubung (Google, Todoist, Apple)",
      "howWeUse": "Bagaimana Kami Menggunakan Informasi Anda",
      "howWeShare": "Bagaimana Kami Membagikan Informasi Anda",
      "dataRetention": "Penyimpanan Data",
      "yourRights": "Hak Privasi Anda",
      "california": "Penduduk California (CCPA / CPRA)",
      "cookies": "Kuki & Penyimpanan Lokal",
      "security": "Keamanan Data",
      "changes": "Perubahan pada Kebijakan Ini",
      "contact": "Hubungi Kami"
    }
  },
  "deleteAccount": {
    "intro": "Menghapus akun akan menghapus secara permanen:",
    "list": {
      "account": "Akun dan profil Anda",
      "tasks": "Semua tugas",
      "notes": "Semua catatan",
      "verses": "Ayat tersimpan",
      "billing": "Riwayat langganan"
    },
    "irreversible": "Tindakan ini tidak dapat dibatalkan.",
    "appleNotice": "Menghapus akun tidak membatalkan langganan yang dibeli melalui App Store. Mohon batalkan juga di Pengaturan → Apple ID → Langganan.",
    "manageSubscription": "Kelola langganan",
    "continueBtn": "Lanjutkan penghapusan",
    "keepBtn": "Pertahankan akun saya",
    "confirmTitle": "Hapus akun Anda?",
    "confirmDesc": "Akun Anda beserta seluruh datanya akan dihapus secara permanen. Tindakan ini tidak dapat dibatalkan.",
    "confirmBtn": "Hapus akun saya secara permanen",
    "deleting": "Menghapus…",
    "error": "Kami tidak dapat menghapus akun Anda. Periksa koneksi Anda dan coba lagi."
  }
}
